// extracted by mini-css-extract-plugin
export default {"header":"Header_header__D83WM","user-infor":"Header_user-infor__ISc2P","display-name":"Header_display-name__If-G2","action":"Header_action__dmclB"};